import React, { useEffect, useRef } from "react";
import "./MainSwitch.scss";

import classNames from "classnames";
import { Navigate, Route, Routes, useLocation } from "react-router";
import { useDispatch, useSelector } from "../../redux/store";
import { UserRole } from "../../types/role";
import Cenik from "../main/Cenik/Cenik";
import CenovePonuky from "../main/CenovePonuky/CenovePonuky";
import KontaktyWrapper from "../main/Kontakty/KontaktyWrapper";
import Obraty from "../main/Obraty/Obraty";
import Pouzivatelia from "../main/Pouzivatelia/Pouzivatelia";
import Skupiny from "../main/Skupiny/Skupiny";
import Uvod from "../main/Uvod/Uvod";
import ZFaDL from "../main/ZFaDL/ZFaDL";
import { wrapWithUserPermission } from "./utils";
import Login from "../Login/Login";
import { useQueryWithPopupErrorHandling } from "../../providers/utils/hooks";
import {
  CHECK_AUTH,
  GET_USER_FROM_COOKIE,
} from "../../redux/actions/userActions";
import { LOGOUT_USER } from "../../redux/actions/authActions";
import { useLoadNecessaryData } from "./useLoadNecessaryData";

interface Props {}

const MainSwitch: React.FC<Props> = ({}: Props) => {
  const auth = useSelector(({ auth }) => auth);
  const location = useLocation();
  const wrapperRef = useRef<HTMLDivElement>(null);

  const dispatch = useDispatch();
  const { call } = useQueryWithPopupErrorHandling();
  useLoadNecessaryData();

  useEffect(() => {
    const cookieUser = GET_USER_FROM_COOKIE();

    if (cookieUser.payload) {
      call(
        () => CHECK_AUTH(),
        null,
        null,
        () => {
          dispatch(cookieUser);
        },
        () => {
          dispatch(LOGOUT_USER());
        }
      );
    } else {
      dispatch(LOGOUT_USER());
    }
  }, []);

  const transitionEnd = () => {
    wrapperRef.current?.classList.add("moved-in");
    wrapperRef.current?.classList.remove("move-in");
  };

  useEffect(() => {
    if (auth.logged) {
      wrapperRef.current?.classList.remove("transition");
      wrapperRef.current?.classList.remove("move-in");
      wrapperRef.current?.classList.remove("moved-in");

      setTimeout(() => {
        wrapperRef.current?.classList.add("move-in");
        wrapperRef.current?.classList.add("transition");
      }, 10);

      wrapperRef.current?.addEventListener("transitionend", transitionEnd);
      return () => {
        wrapperRef.current?.removeEventListener("transitionend", transitionEnd);
      };
    }
  }, [location.pathname, auth.logged]);

  return (
    <div
      className={classNames("switchWrapper", { noAnimation: !auth.logged })}
      ref={wrapperRef}
    >
      <Routes>
        <Route
          path="/"
          element={wrapWithUserPermission(<Uvod />, {
            permission: UserRole.Obchodnik,
          })}
        />
        <Route
          path="/cennik"
          element={wrapWithUserPermission(<Cenik />, {
            permission: UserRole.Obchodnik,
          })}
        />
        <Route
          path="/kontakty"
          element={wrapWithUserPermission(<KontaktyWrapper />, {
            permission: UserRole.Obchodnik,
          })}
        />
        <Route
          path="/kontakty/:id"
          element={wrapWithUserPermission(<KontaktyWrapper />, {
            permission: UserRole.Obchodnik,
          })}
        />
        <Route
          path="/cenove-ponuky"
          element={wrapWithUserPermission(<CenovePonuky />, {
            permission: UserRole.Obchodnik,
          })}
        />
        <Route
          path="/cenove-ponuky/:id"
          element={wrapWithUserPermission(<CenovePonuky />, {
            permission: UserRole.Obchodnik,
          })}
        />
        <Route
          path="/cenove-ponuky/kontakt/:kontakt"
          element={wrapWithUserPermission(<CenovePonuky />, {
            permission: UserRole.Obchodnik,
          })}
        />
        <Route
          path="/obraty"
          element={wrapWithUserPermission(<Obraty />, {
            permission: UserRole.Obchodnik,
          })}
        />
        <Route
          path="/obraty/kontakt/:kontakt"
          element={wrapWithUserPermission(<Obraty />, {
            permission: UserRole.Obchodnik,
          })}
        />
        <Route
          path="/cs-skupiny"
          element={wrapWithUserPermission(<Skupiny />, {
            permission: UserRole.Obchodnik,
          })}
        />
        <Route
          path="/zfadl"
          element={wrapWithUserPermission(<ZFaDL />, {
            permission: UserRole.Obchodnik,
          })}
        />
        <Route
          path="/pouzivatelia"
          element={wrapWithUserPermission(<Pouzivatelia />, {
            permission: UserRole.Root,
          })}
        />
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </div>
  );
};

export default MainSwitch;
